import React from 'react';
import {
  ALL_TRADES,
  findTradeSubserviceById,
  findSubserviceAcrossTrades,
} from '../constants/mockData/allTrades';
import { getSubServiceIcon } from '../constants/serviceIcons';

const CATALOG_SUBSERVICE_ICON_SX = { fontSize: '80px' };

export function isCustomSubServiceType(subServiceType) {
  return typeof subServiceType === 'string' && subServiceType.startsWith('custom-');
}

function titleCaseSlug(slug) {
  if (!slug || typeof slug !== 'string') return 'Service';
  return slug
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Whether this sub row is business-defined (custom id).
 */
export function isBusinessDefinedSubservice(sub) {
  if (!sub || typeof sub !== 'object') return false;
  return sub.IsCustom === true || isCustomSubServiceType(sub.SubServiceType);
}

/**
 * Display title: custom → Title; catalog → catalog label from SubServiceType.
 */
export function resolveSubserviceTitle(serviceType, sub) {
  if (!sub) return 'Service';

  if (isBusinessDefinedSubservice(sub)) {
    const title = typeof sub.Title === 'string' ? sub.Title.trim() : '';
    return title || titleCaseSlug(sub.SubServiceType);
  }

  const trade = ALL_TRADES.find((t) => t.id === serviceType);
  const meta = trade
    ? findTradeSubserviceById(trade, sub.SubServiceType)
    : findSubserviceAcrossTrades(sub.SubServiceType)?.subservice;
  return meta?.label || titleCaseSlug(sub.SubServiceType);
}

/**
 * Optional card tagline (both catalog and custom).
 */
export function resolveSubserviceTagline(sub) {
  if (!sub) return null;

  const raw =
    typeof sub.Tagline === 'string' && sub.Tagline.trim() ? sub.Tagline.trim() : null;
  return raw || null;
}

/**
 * Icon for a catalog subservice card (`allTrades` shape: `{ id, icon?, ... }`).
 * @param {{ id?: string, icon?: import('@mui/material').SvgIconComponent } | null | undefined} catalogSubservice
 */
export function renderCatalogSubserviceIcon(catalogSubservice) {
  if (catalogSubservice?.icon) {
    const Icon = catalogSubservice.icon;
    return <Icon sx={CATALOG_SUBSERVICE_ICON_SX} />;
  }
  return getSubServiceIcon(catalogSubservice?.id);
}